import React, { Component } from "react";
import style from "./style.css";
import CSSModule from "react-css-modules";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import cookie from "react-cookie";

import {
  getPackage,
  buyPackage,
  getRetail,
  buyRetail,
  buyVIP,
} from "../../actions";
import $ from "jquery";
import rule from "../../config/rule.js";
import TextFeild from "../../component/textFeild";
import Button from "../../component/button";

import DropList from "../../component/dropList";
import Bill from "../../component/bill";

const vipData = {
  charge_point: 1,
  charge_per_price: 2000,
  disable: false,
  name: "升級VIP",
  type: "normal",
  item_name: "升級VIP資格（期限一年）",
  love_codes: [
    {
      code: 5050520,
      name: "中華武學人文推廣協會",
    },
  ],
};

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: 8585,
      choosed: null,
      data: {},
      formData: {
        name: "",
        ubn: "",
      },
    };
    //console.log(this.props.params.pathParam);
    this.isRetail = parseInt(this.props.params.pathParam) === 0 ? true : false;

    this.handleChange = (e) => {
      this._clearError();
      this.setState({
        choosed: e.currentTarget.value,
      });
    };
    this.onSelected = (value) => {
      this._clearError();
      this.setState({
        code: value.code,
      });
    };
    this.inputOnChange = (name, value) => {
      this._clearError();
      this.state.formData[name] = value;
      this.setState(this.state.formData);
    };
    this.handleSubmit = (e) => {
      if (this._checkValid(this.state)) {
        const { choosed, code, formData } = this.state;
        const productId = parseInt(this.props.routeParams.pathParam);
        switch (productId) {
          case -1:
            delete this.postData.package_id;
            this.props.buyVIP(this.postData).then((res) => {
              if (res.status === "OK") {
                window.location.href = res.url;
              } else alert("發生錯誤，請稍後再試");
            });
            break;
          case 0:
            this.postData = {
              receipt_option: this.postData,
              point: this.state.data.charge_point,
            };

            this.props.buyRetail(this.postData).then((res) => {
              if (res.status === "OK") {
                window.location.href = res.url;
              } else alert("發生錯誤，請稍後再試");
            });
            break;
          default:
            this.postData.package_id = productId;
            this.props.buyPackage(this.postData).then((res) => {
              if (res.status === "OK") {
                window.location.href = res.url;
              } else alert("發生錯誤，請稍後再試");
            });
            break;
        }
      }
    };
    this.retailSelect = (value) => {
      this.state.data.charge_point = value.label;
      this.setState(this.state.data);
    };
  }

  componentDidMount() {
    const productId = parseInt(this.props.routeParams.pathParam);

    switch (productId) {
      case -1:
        this.setState({
          data: vipData,
        });
        break;
      case 0:
        this.props.getRetail().then((res) => {
          res.charge_point = 1;
          this.setState({
            data: res,
          });
        });
        break;
      default:
        this.props.getPackage({ id: productId }).then((res) => {
          this.setState({
            data: res,
          });
        });
        break;
    }
  }

  render() {
    // const data = this.props.packagePool["package_"+this.props.routeParams.pathParam];
    // //console.log(this.props.packagePool);
    let listContent = [];

    if (this.state.data.love_codes && this.state.data.love_codes.length > 0) {
      this.state.data.love_codes.forEach((obj, index) => {
        listContent.push({ label: obj.name, code: obj.code });
      });
    }

    if (!this.state.data || !this.state.data.hasOwnProperty("charge_point"))
      return null;

    return (
      <div styleName="container">
        <h2>訂單</h2>
        {this.state.data && (
          <Bill
            data={this.state.data}
            isRetail={this.isRetail}
            onSelected={this.retailSelect}
          />
        )}
        <h2>使用條款</h2>
        <textarea styleName="rule" value={rule} disabled={true} />
        <div styleName="flexbox">
          <div styleName="row-1">
            <h3>統一發票</h3>
          </div>
          <div styleName="row-2 ">
            <div styleName="radioGroup">
              <input
                id="switch1"
                label="個人電子發票 捐贈"
                value={"LOVE"}
                onChange={this.handleChange}
                checked={this.state.choosed === "LOVE"}
                type="radio"
              />
              <label htmlFor="switch1">
                <div styleName="check"></div>個人電子發票 捐贈
              </label>
              <DropList
                styleName="list"
                defaultIndex={1}
                listContent={listContent}
                onSelected={this.onSelected}
                width={130}
              />
            </div>
            <div styleName="radioGroup">
              <input
                id="switch2"
                label="個人電子發票"
                value={"B2C"}
                onChange={this.handleChange}
                type="radio"
                checked={this.state.choosed === "B2C"}
              />
              <label htmlFor="switch2">
                <div styleName="check"></div>個人電子發票
              </label>
            </div>
            <div styleName="radioGroup">
              <input
                id="switch3"
                label="個人電子發票 (索取紙本列印，教室領取)"
                value={"print"}
                onChange={this.handleChange}
                type="radio"
                checked={this.state.choosed === "print"}
              />
              <label htmlFor="switch3">
                <div styleName="check"></div>個人發票 (索取紙本列印，教室領取)
              </label>
            </div>
            <div styleName="radioGroup">
              <input
                id="switch4"
                label="企業電子發票"
                value={"B2B"}
                onChange={this.handleChange}
                checked={this.state.choosed === "B2B"}
                type="radio"
              />
              <label htmlFor="switch4">
                <div styleName="check"></div>企業電子發票
              </label>
            </div>
            {this.state.choosed === "B2B" && (
              <div>
                <div styleName="inputBox">
                  <span>買受人</span>
                  <TextFeild
                    styleName="input"
                    value={this.state.formData["name"]}
                    type="text"
                    name="name"
                    onError={this.onError}
                    onChange={this.inputOnChange}
                  />
                </div>

                <div styleName="inputBox" style={{ marginTop: "5px" }}>
                  <span>統一編號</span>
                  <TextFeild
                    styleName="input"
                    value={this.state.formData["ubn"]}
                    type="text"
                    name="ubn"
                    onError={this.onError}
                    onChange={this.inputOnChange}
                  />
                </div>
              </div>
            )}
            <p styleName="error">{this.state.errorMessage}</p>
            <Button onClick={this.handleSubmit} styleName="button">
              同意條款並購買
            </Button>
          </div>
        </div>
      </div>
    );
  }
  _checkValid(state) {
    const { choosed, code, formData } = state;
    switch (choosed) {
      case "LOVE":
        if (code === "") return this._setError("請選擇捐贈單位");
        else {
          this.postData = {
            type: choosed,
            code: code,
          };
          return true;
        }
      case "B2C":
        this.postData = { type: choosed, print: false };
        return true;
      case "print":
        this.postData = {
          type: "B2C",
          print: true,
        };
        return true;
      case "B2B":
        if (formData.name === "") return this._setError("請填寫買受人");
        else if (formData.ubn === "") return this._setError("請填寫統一編號");
        else {
          this.postData = {
            type: choosed,
            name: formData.name,
            ubn: formData.ubn,
          };
          return true;
        }
      default:
        return this._setError("請選擇統一發票格式");
    }
  }
  _clearError() {
    this.setState({ errorMessage: "" });
  }
  _setError(errorMessage) {
    this.setState({ errorMessage: errorMessage });
    return false;
  }
  _formPost(path, params, method) {
    method = method || "post"; // Set method to post by default if not specified.

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    //console.log(form);
    form.submit();
  }
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, {
  getPackage,
  buyPackage,
  getRetail,
  buyRetail,
  buyVIP,
})(CSSModule(Product, style, { allowMultiple: true }));



/** WEBPACK FOOTER **
 ** ./src/container/product/index.js
 **/